import { useClearReportViewOnLeave } from "../useClearReportViewOnLeave";
import { useNavigate } from "react-router-dom";
import { BackBtn } from "../../Users/components/logIncident/logIncident.style";
import { ArrowLeftIcon } from "@heroicons/react/20/solid";
import { GoPencil } from "react-icons/go";
import type { MenuProps } from "antd";
import { Button } from "antd";
import { FaBell } from "react-icons/fa6";

import styled from "styled-components";
import {
  useAdminWrapper,
  useAnalyticsWrapper,
  useReportWrapper,
  useStoreWrapper,
} from "../../../../store/store";
import { BigBoldText } from "../../dashboard/home/home.style";
import moment from "moment";
import useAnalytics from "../../../../hooks/useAnalytics";
import { useEffect, useRef, useState } from "react";
import { LayerContainer } from "./style";
import { ExcelExport } from "@progress/kendo-react-excel-export";
import { Workbook } from "@progress/kendo-ooxml";
import { PDFExport } from "@progress/kendo-react-pdf";
import { woundAnalysisDetailCols } from "../dummyData/colums";
import useIncident from "../../../../hooks/useIncident";
import useIncidentTypes from "../../../../hooks/useIncidentTypes";
import { viewClickedIncident } from "../../../../utils/helpers/incidentListUtils";
import {
  handleCSVDownload,
  handlePDFDownload,
} from "../../../../utils/helpers/pdfCsvUtils";
// NOTE: FilterModal is shared across all analytics reports (incident-list, status, repeat, trend, wound-analysis)
// despite living in fall-analysis folder. Consider renaming path for clarity.
import FilterModal from "../fall-analysis/FilterModal";
import EmailSubscriptionForm from "./form/EmailSubForm";
import Modalant from "../../../../components/ModalA/Modalant";
import useSubscriptions from "../../../../hooks/useSubscriptions";
import { toast } from "react-toastify";

// Import section components - these would need to be created
import SectionModal from "./sections/SectionModal";
import RestoredDrilldown from "../drilldown/RestoredDrilldown";
import WoundIncidentsByUnit from "./sections/WoundIncidentsByUnit";
import BodyAreaAnalysis from "./sections/BodyAreaAnalysis";
import RepeatSkinIncidents from "./sections/RepeatSkinIncidents";
import SkinIncidentTrend from "./sections/SkinIncidentTrend";
import KpiSummary from "./sections/KpiSummary";
import DayOfWeek from "./sections/DayOfWeek";
import SkinInjuryTypeByMonth from "./sections/SkinInjuryTypeByMonth";
import CaregiversReporting from "./sections/CaregiversReporting";
import WoundOrigin from "./sections/WoundOrigin";
import PressureUlcerStaging from "./sections/PressureUlcerStaging";
import ShiftAndTime from "./sections/ShiftAndTime";
import MobilityStatus from "./sections/MobilityStatus";

export const HeaderSection = styled.section`
  display: flex;
  @media screen and (max-width: 768px) {
    flex-direction: column;
  }
`;
export const DateModBtnViewBtnContainer = styled.div``;

export const TitleContainer = styled.div``;
export const ModifyComponent = styled.div`
  width: 30%;
  display: flex;
  flex-direction: column;
  position: relative;
`;
export const DateDisplayModifyBtnContainer = styled.div`
  border: 1px solid #d9d9d9;
  /* border-radius: 4px 0px 4px 4px; */
`;
export const ModifyBtn = styled.button`
  color: #fff;
  border-left: none;
  border-right: 1px solid #d9d9d9;
  border-bottom: 1px solid #d9d9d9;
  /* border-top: none; */
  /* border-bottom: none; */
  background-color: #fff;
  cursor: pointer;
  background-color: var(--main-purple-light);
`;
const ActBtn = styled.button`
  color: #b580ff;
  border: 1px solid #d9d9d9;
  background-color: #fff;
  cursor: pointer;
`;
export const ViewandExportReportBtnContainer = styled.div``;
export const ViewBtnsContainer = styled.div`
  /* width: 100%; */
`;

const WoundAnalysisReport = () => {
  useClearReportViewOnLeave("wound");
  const navigate = useNavigate();

  const [clickedIncident, setClickedIncident] = useState<any>({});
  const [woundData, setWoundData] = useState<any>(null);

  const [modalData, setModalData] = useState<any>({
    viewModal: false,
    data: null,
    viewType: "",
  });
  const [showFilterModal, setShowFilterModal] = useState<boolean>(false);
  const [showSubscriptionModal, setShowSubscriptionModal] =
    useState<boolean>(false);

  const { createForm, updateForm, user } = useStoreWrapper((state) => ({
    createForm: state.createForm,
    updateForm: state.updateForm,
    user: state.user,
  }));

  const { setIncident } = useReportWrapper((state) => ({
    setIncident: state.setIncident,
  }));

  const { getIncidentDetailsWithId } = useIncident({
    selectedIncidentId: clickedIncident?.incidentId
      ? clickedIncident?.incidentId
      : clickedIncident?.IncidentId,
  });

  const {
    refetch: refetchSelectedIncident,
    isFetching: isFetchingSelectedIncident,
  } = getIncidentDetailsWithId;

  const { incidentTypes: incidentTypesObject } = useIncidentTypes();
  const { handlePostSubscription } = useSubscriptions({});
  const { isLoading: isLoadingSubscription, mutateAsync: doPostSubscription } =
    handlePostSubscription;

  const {
    startDate,
    endDate,
    woundFacility,
    woundAnalysisIncidents,
    reportType,
    globalAnalyticsSelectedWoundType,
    setStartDate,
    setEndDate,
    setWoundFacility,
    setGlobalAnaylyticsFacility,
    setReportType,
  } = useAnalyticsWrapper((state) => ({
    startDate: state.startDate,
    endDate: state.endDate,
    woundFacility: state.woundFacility,
    woundAnalysisIncidents: state.woundAnalysisIncidents,
    reportType: state.reportType,
    globalAnalyticsSelectedWoundType: state.globalAnalyticsSelectedWoundType,
    setStartDate: state.setStartDate,
    setEndDate: state.setEndDate,
    setWoundFacility: state.setWoundFacility,
    setGlobalAnaylyticsFacility: state.setGlobalAnaylyticsFacility,
    setReportType: state.setReportType,
  }));

  const handleBack = () => {
    setEndDate("");
    setStartDate("");
    setWoundFacility(null);
    setReportType("");
    navigate("/user/analytics");
    setGlobalAnaylyticsFacility(null);
  };

  useEffect(() => {
    // Set report type for GeneralForm to know which fields to display
    setReportType("wound-analysis");
  }, []);

  useEffect(() => {
    if (woundFacility === null || woundFacility === undefined) {
      navigate("/user/analytics");
    }
  }, [woundFacility]);

  const { getIncidentListAnalysis } = useAnalytics({
    facility: woundFacility?.value || "",
    startDate: moment(startDate).format("yyyy-MM-DD"),
    endDate: moment(endDate).format("yyyy-MM-DD"),
  });

  const {
    data: incidentListAnalysisData,
    isFetching: isFetchingIncidentListAnalysis,
  } = getIncidentListAnalysis;

  const disableViewBtn = isFetchingIncidentListAnalysis;

  useEffect(() => {
    if (woundAnalysisIncidents !== undefined) {
      const _woundData = woundAnalysisIncidents;
      setWoundData(_woundData);
      setModalData({
        viewModal: false,
        data: woundAnalysisIncidents?.allIncidents,
        viewType: "incident-list",
      });
    }
  }, [woundAnalysisIncidents]);

  useEffect(() => {
    if (
      clickedIncident?.incidentId?.length > 0 ||
      clickedIncident?.IncidentId?.length > 0
    ) {
      const refetchedData = async () => {
        try {
          const response = await refetchSelectedIncident();
          const selectedIncident = response?.data?.data?.data;
          const incidentType = incidentTypesObject.find(
            (incident: any) => incident.flag === selectedIncident.RecordTypeId
          );
          setIncident(selectedIncident);
          viewClickedIncident(
            createForm,
            updateForm,
            selectedIncident,
            incidentType,
            navigate
          );
        } catch (err) {
          console.log({ err });
        }
      };
      refetchedData();
    }
  }, [clickedIncident]);

  // ----- Report export (PDF + Excel) -----
  const excelExporter = useRef<ExcelExport>(null);
  const woundPDFExportRef = useRef<PDFExport>(null);

  // PDF: render the whole report module via Kendo PDFExport (same approach as Fall Analysis).
  // The previous html2canvas-based multi-export silently failed in Chrome on the page CSS/canvases.
  const triggerPDFDownload = () => {
    if (woundPDFExportRef.current) {
      woundPDFExportRef.current.save();
    }
  };

  // Excel: build one sheet from the consolidated woundAnalysisIncidents payload.
  const handleExcelExport = () => {
    if (!excelExporter.current) return;
    const d = woundAnalysisIncidents || {};

    const titleRow = (text: string) => ({
      cells: [{ value: text, bold: true, fontSize: 14 }],
    });
    const headerRow = (labels: string[]) => ({
      cells: labels.map((l) => ({ value: l, bold: true, background: "#f0f0f0" })),
    });
    const row = (vals: any[]) => ({ cells: vals.map((v) => ({ value: v })) });
    const blank = () => ({ cells: [{ value: "" }] });
    const pct = (v: any) =>
      v === undefined || v === null ? "" : `${Math.round(Number(v))}%`;

    // Sheet section order mirrors the on-screen report top-to-bottom (Body Area sits above Day of Week, etc.).
    const rows: any[] = [titleRow("Wound / Skin Incident Analysis")];

    // §1 KPI
    if (d.kpiSummary) {
      const k = d.kpiSummary;
      rows.push(blank(), headerRow(["Summary", "Count"]));
      rows.push(
        row(["Total Incidents", k.totalIncidents ?? 0]),
        row(["Pressure Ulcers", k.pressureUlcers ?? 0]),
        row(["Other Wounds", k.otherWounds ?? 0]),
        row(["House Acquired", k.houseAcquired ?? 0]),
        row(["On Admission", k.onAdmission ?? 0]),
        row(["Skin Tears", k.skinTears ?? 0])
      );
    }

    // §2 Monthly Trend summary (Pressure Ulcers vs Other vs Total) — the on-screen §2 table.
    if (d.skinIncidentTrend?.summary) {
      const s = d.skinIncidentTrend.summary;
      const puCount = s.pressureUlcerCount ?? 0;
      const puPct = s.pressureUlcerPercentage ?? 0;
      const totalInc = s.totalIncidents ?? 0;
      rows.push(
        blank(),
        titleRow("Monthly Trend — Total Wounds vs Pressure Ulcers vs Other"),
        headerRow(["Type", "# of Incidents", "%"]),
        row(["Pressure Ulcers", puCount, pct(puPct)]),
        row(["Other", totalInc - puCount, pct(100 - puPct)]),
        row(["Total", totalInc, pct(100)])
      );
    }

    // §3 Wound Origin
    if (d.woundOrigin?.originBreakdown?.length) {
      rows.push(
        blank(),
        titleRow("Wound Origin"),
        headerRow(["Origin", "New", "Reoccurrence", "Total", "%"])
      );
      d.woundOrigin.originBreakdown.forEach((r: any) =>
        rows.push(row([r.origin, r.new, r.reoccurrence, r.total, pct(r.percentage)]))
      );
    }

    // §4 PU Staging by month
    if (d.pressureUlcerStaging?.stagingByMonth?.length) {
      const months: string[] = d.pressureUlcerStaging.months ?? [];
      rows.push(
        blank(),
        titleRow("Pressure Ulcer Staging"),
        headerRow(["Stage", ...months, "Total", "%"])
      );
      d.pressureUlcerStaging.stagingByMonth.forEach((r: any) =>
        rows.push(
          row([
            r.stage,
            ...months.map((m) => r.monthlyCounts?.[m] ?? 0),
            r.total,
            pct(r.percentage),
          ])
        )
      );
    }

    // §8 Body Area (sits above Day of Week to match the on-screen order)
    if (d.bodyAreaAndLocation?.bodyAreaAnalysis?.length) {
      rows.push(blank(), titleRow("Body Area Analysis"), headerRow(["Area", "Number"]));
      d.bodyAreaAndLocation.bodyAreaAnalysis.forEach((r: any) =>
        rows.push(row([r.area, r.incidentCount]))
      );
    }

    // §5 Day of Week
    if (d.dayOfWeek?.dayBreakdown?.length) {
      rows.push(blank(), titleRow("Day of Week"), headerRow(["Day", "Count", "%"]));
      d.dayOfWeek.dayBreakdown.forEach((r: any) =>
        rows.push(row([r.day, r.count, pct(r.percentage)]))
      );
    }

    // §6 Shift & Time — one block per shift with its time bands + a Total row (mirrors the on-screen grids).
    if (d.shiftAndTime) {
      ["Morning Shift", "Afternoon Shift", "Night Shift"].forEach((s) => {
        const bands = d.shiftAndTime[s];
        if (bands?.length) {
          rows.push(blank(), titleRow(s), headerRow(["Time", "#", "%"]));
          bands.forEach((r: any) =>
            rows.push(row([r.shift, r.count, pct(r.percentage)]))
          );
          const totalCount = bands.reduce(
            (sum: number, r: any) => sum + (r.count ?? 0),
            0
          );
          const totalPct = bands.reduce(
            (sum: number, r: any) => sum + (Number(r.percentage) || 0),
            0
          );
          rows.push(row(["Total", totalCount, pct(totalPct)]));
        }
      });
    }

    // §7 By Unit
    if (d.skinIncidentsByUnit?.unitBreakdown?.length) {
      rows.push(
        blank(),
        titleRow("Skin Incidents by Unit"),
        headerRow(["Unit", "# Incidents", "Pressure Ulcers", "Skin Tears", "Bruises", "Rashes", "Other"])
      );
      d.skinIncidentsByUnit.unitBreakdown.forEach((r: any) => {
        const other =
          (r.totalIncidents ?? 0) -
          ((r.pressureInjuries ?? 0) + (r.skinTears ?? 0) + (r.bruises ?? 0) + (r.rashes ?? 0));
        rows.push(
          row([r.unit, r.totalIncidents, r.pressureInjuries, r.skinTears, r.bruises, r.rashes, other])
        );
      });
    }

    // §9 Mobility — only the Mobility x Wound Type cross-tab (the on-screen report shows the bar chart
    // + cross-tab and no standalone breakdown table; the bar has no Excel equivalent).
    if (d.mobilityStatus?.crossTab?.length) {
      rows.push(
        blank(),
        titleRow("Mobility x Wound Type"),
        headerRow(["Mobility", "Pressure Ulcer", "Skin Tear", "Trauma", "Blister", "Other", "Total"])
      );
      d.mobilityStatus.crossTab.forEach((r: any) =>
        rows.push(
          row([r.mobility, r.pressureUlcer, r.skinTear, r.trauma, r.blister, r.other, r.total])
        )
      );
    }

    // §10 Skin Injury Type by Month
    if (d.skinInjuryTypeByMonth?.injuryByMonth?.length) {
      const months: string[] = d.skinInjuryTypeByMonth.months ?? [];
      rows.push(
        blank(),
        titleRow("Skin Injury Type by Month"),
        headerRow(["Skin Injury Type", ...months, "Total", "%"])
      );
      d.skinInjuryTypeByMonth.injuryByMonth.forEach((r: any) =>
        rows.push(
          row([
            r.injuryType,
            ...months.map((m) => r.monthlyCounts?.[m] ?? 0),
            r.total,
            pct(r.percentage),
          ])
        )
      );
    }

    // §11 Repeat residents
    if (d.repeatSkinIncidents?.residentBreakdown?.length) {
      rows.push(
        blank(),
        titleRow("Repeat Skin Incidents by Resident"),
        headerRow(["Resident", "Number", "%"])
      );
      d.repeatSkinIncidents.residentBreakdown.forEach((r: any) =>
        rows.push(row([r.residentName, r.incidentCount, pct(r.percentage)]))
      );
    }

    // §12 Caregivers — Caregiver / Number / % (Fall-style; earlier unit/woundTypes/stage/review columns were dropped).
    if (d.caregiversReporting?.caregiverBreakdown?.length) {
      rows.push(
        blank(),
        titleRow("Caregivers Reporting Multiple Incidents"),
        headerRow(["Caregiver", "Number", "%"])
      );
      d.caregiversReporting.caregiverBreakdown.forEach((r: any) =>
        rows.push(row([r.caregiverName, r.count, pct(r.percentage)]))
      );
    }

    const workbook = new Workbook();
    workbook.sheets = [
      {
        name: "Wound Analysis",
        columns: Array.from({ length: 8 }, () => ({ autoWidth: true })),
        rows,
      },
    ];
    (excelExporter.current as ExcelExport).save(workbook);
  };

  const items: MenuProps["items"] = [
    {
      key: "1",
      label: (
        <Button
          onClick={(prev) => setShowSubscriptionModal((prev) => !prev)}
          className="flex w-full items-center border-0"
        >
          <FaBell /> Subscribe
        </Button>
      ),
    },
  ];

  const handleOutsideClick = (event: MouseEvent) => {
    const target = event.target as HTMLElement;
    if (showFilterModal && !target.closest(".modify-btn-container")) {
      setShowFilterModal(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleOutsideClick);
    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, [showFilterModal]);

  interface FormData {
    startDate: string;
    endDate: string;
    startTime: string;
    recurrence: string;
    description: string;
    weeklyDays?: string;
    monthlyDay?: string;
    periodType: string;
    periodLength: string;
  }

  const handleFormSubmit = async (data: FormData) => {
    const subscription = {
      Report_Type__c: "Wound Analytics",
      Incident_Types__c: "Skin Issue",
      Start_Date__c: data.startDate,
      End_Date__c: data.endDate,
      Interval_Type__c: data.recurrence,
      Description__c: data.description,
      Trailing_Period__c: data.periodType,
      Trailing_Period_Quantity__c: data.periodLength,
      Skin_Issue_Types: globalAnalyticsSelectedWoundType?.join(";") || "",
      User__c: user.userId,
      Facility__c: woundFacility?.value,
      Facilities__c:
        "a01TO000000h3kEYAQ,a01TO000000h3kEYAQ,a01VD00000QrTw9YAF,a01VD00000QrTw9YAF",
      ...(data.recurrence === "weekly" && {
        Day_Of_The_Week__c: data.weeklyDays,
      }),
      ...(data.recurrence === "monthly" && {
        Day_Of_The_Month__c: data.monthlyDay,
      }),
    };

    try {
      const res = await doPostSubscription({ subscription });
      toast.success(res.data.message);
      setShowSubscriptionModal(false);
    } catch (err) {
      console.log({ err });
    }
  };

  return (
    <div>
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <BackBtn onClick={() => handleBack()}>
          <ArrowLeftIcon width="30px"></ArrowLeftIcon>
          Back to report categories
        </BackBtn>
      </div>
      <HeaderSection className="flex flex-col">
        <TitleContainer className="relative mt-7">
          <BigBoldText
            className="capitalize text-purple-400"
            data-testid="report-title"
          >
            {woundFacility[0]?.label} - Wound Analysis
          </BigBoldText>
        </TitleContainer>

        <DateModBtnViewBtnContainer className="mt-3 flex flex-col justify-between md:flex-row">
          <ModifyComponent className="modify-btn-container w-full md:w-2/5">
            <div className="flex flex-row">
              <DateDisplayModifyBtnContainer className="mb-4 flex h-10 w-full items-center justify-between border-t border-solid border-gray-200 pl-2">
                <p className="text-sm text-purple-400">
                  {moment(startDate).format("LL")} -{" "}
                  {moment(endDate).format("LL")}
                </p>
              </DateDisplayModifyBtnContainer>
              <ModifyBtn
                data-testid="modify-report-params-btn"
                onClick={() => setShowFilterModal((prev) => !prev)}
                className="flex h-10 flex-row items-center justify-between border border-gray-200 px-4 py-2 text-sm"
              >
                <GoPencil className="mr-2" />
                Modify
              </ModifyBtn>
            </div>

            <FilterModal
              open={showFilterModal}
              subtitle="Advanced Wound Analysis"
              closeFn={() => setShowFilterModal(false)}
              filterType="general"
              isModifyMode={showFilterModal}
            />
          </ModifyComponent>
          <ViewandExportReportBtnContainer className="flex h-10 items-end justify-between">
            <ViewBtnsContainer className="mr-2 flex gap-3">
              {/* Button to open the Incident List Modal */}
              <ActBtn
                className="text-white h-10 rounded px-4 py-2 text-sm disabled:opacity-50"
                onClick={() =>
                  setModalData({
                    viewModal: true,
                    data: woundData?.allIncidents,
                    viewType: "incident-list",
                  })
                }
                disabled={disableViewBtn}
              >
                Incident List
              </ActBtn>
              {/* subscription buttons for desktop */}
              {/* Buttons for the subscription modal */}
              <div className="hidden gap-2 lg:flex">
                {items?.map((item) => (
                  <ActBtn
                    className="text-white h-10 rounded px-4 py-2 text-sm disabled:opacity-50"
                    key={item?.key}
                    // @ts-ignore
                    onClick={item?.label?.props?.onClick}
                  >
                    {/* @ts-ignore */}
                    {item?.label?.props?.children}
                  </ActBtn>
                ))}
              </div>
              <ActBtn
                className="text-white h-10 rounded px-4 py-2 text-sm disabled:opacity-50"
                onClick={triggerPDFDownload}
                disabled={disableViewBtn}
              >
                Export PDF
              </ActBtn>
              <ActBtn
                className="text-white h-10 rounded px-4 py-2 text-sm disabled:opacity-50"
                onClick={handleExcelExport}
                disabled={disableViewBtn}
              >
                Export Excel
              </ActBtn>
            </ViewBtnsContainer>
          </ViewandExportReportBtnContainer>
        </DateModBtnViewBtnContainer>
      </HeaderSection>

      <PDFExport
        ref={woundPDFExportRef}
        paperSize="A3"
        landscape={true}
        margin="1cm"
        fileName={`${woundFacility?.label ?? woundFacility?.[0]?.label ?? "Wound"} - Wound Analysis Report ${moment(startDate).format("MM-DD-YYYY")} to ${moment(endDate).format("MM-DD-YYYY")}.pdf`}
      >
      <div id="wound-analysis-module" className="relative">
        <div className="relative top-7 mt-7">
          <LayerContainer
            id="kpiSummary"
            className="pdfExport border-zinc-300 shadow-md"
          >
            <KpiSummary />
          </LayerContainer>
          <LayerContainer
            id="skinIncidentTrend"
            className="pdfExport border-zinc-300 shadow-md"
          >
            <SkinIncidentTrend
              setClickedIncident={(item: any) => setClickedIncident(item)}
              isFetchingSelectedIncident={isFetchingSelectedIncident}
            />
          </LayerContainer>
          <LayerContainer
            id="woundOrigin"
            className="pdfExport border-zinc-300 shadow-md"
          >
            <WoundOrigin
              setClickedIncident={(item: any) => setClickedIncident(item)}
            />
          </LayerContainer>
          <LayerContainer
            id="pressureUlcerStaging"
            className="pdfExport border-zinc-300 shadow-md"
          >
            <PressureUlcerStaging
              setClickedIncident={(item: any) => setClickedIncident(item)}
            />
          </LayerContainer>
          <LayerContainer
            id="bodyAreaAnalysis"
            className="pdfExport border-zinc-300 shadow-md"
          >
            <BodyAreaAnalysis
              setClickedIncident={(item: any) => setClickedIncident(item)}
              isFetchingSelectedIncident={isFetchingSelectedIncident}
            />
          </LayerContainer>
          <LayerContainer
            id="dayOfWeek"
            className="pdfExport border-zinc-300 shadow-md"
          >
            <DayOfWeek
              setClickedIncident={(item: any) => setClickedIncident(item)}
            />
          </LayerContainer>
          <LayerContainer
            id="shiftAndTime"
            className="pdfExport border-zinc-300 shadow-md"
          >
            <ShiftAndTime
              setClickedIncident={(item: any) => setClickedIncident(item)}
            />
          </LayerContainer>
          <LayerContainer
            id="incidentsByUnit"
            className="pdfExport border-zinc-300 shadow-md"
          >
            <WoundIncidentsByUnit
              setClickedIncident={(item: any) => setClickedIncident(item)}
              isFetchingSelectedIncident={isFetchingSelectedIncident}
            />
          </LayerContainer>
          <LayerContainer
            id="mobilityStatus"
            className="pdfExport border-zinc-300 shadow-md"
          >
            <MobilityStatus
              setClickedIncident={(item: any) => setClickedIncident(item)}
            />
          </LayerContainer>
          <LayerContainer
            id="skinInjuryTypeByMonth"
            className="pdfExport border-zinc-300 shadow-md"
          >
            <SkinInjuryTypeByMonth
              setClickedIncident={(item: any) => setClickedIncident(item)}
            />
          </LayerContainer>
          <LayerContainer
            id="repeatSkinIncidents"
            className="pdfExport border-zinc-300 shadow-md"
          >
            <RepeatSkinIncidents
              setClickedIncident={(item: any) => setClickedIncident(item)}
              isFetchingSelectedIncident={isFetchingSelectedIncident}
            />
          </LayerContainer>
          <LayerContainer
            id="caregiversReporting"
            className="pdfExport border-zinc-300 shadow-md"
          >
            <CaregiversReporting
              setClickedIncident={(item: any) => setClickedIncident(item)}
            />
          </LayerContainer>
        </div>
      </div>
      </PDFExport>

      {/* SectionModal for wound analysis */}
      {/* Modal for Incident List Button */}
      <RestoredDrilldown report="wound" Modal={SectionModal} />
      {modalData.viewModal ? (
        <SectionModal
          open={modalData.viewModal}
          facilityName={woundFacility?.label ?? woundFacility?.[0]?.label}
          startDate={startDate}
          endDate={endDate}
          closeFn={() =>
            setModalData({ viewModal: false, data: null, viewType: "" })
          }
          resetFn={() =>
            setModalData({ viewModal: false, data: null, viewType: "" })
          }
          isLoading={isFetchingSelectedIncident}
          tableData={modalData?.data}
          tableCols={woundAnalysisDetailCols()}
          title="Wound Incident List"
          getUserCallback={(item: any) => {
            setClickedIncident(item);
          }}
          handlePdfExport={() =>
            handlePDFDownload({
              data: modalData?.data,
              columnData: woundAnalysisDetailCols(),
              fileName: woundFacility?.label ?? woundFacility?.[0]?.label,
              startDate,
              endDate,
              subTitle: "Wound Incident List",
            })
          }
          handleCsvExport={() =>
            handleCSVDownload(
              modalData?.data,
              woundAnalysisDetailCols(),
              woundFacility?.label ?? woundFacility?.[0]?.label
            )
          }
        />
      ) : null}

      {/* Modal for the Subscribe Button */}
      {showSubscriptionModal && (
        <Modalant
          isLoading={isLoadingSubscription}
          className="items-center md:w-6/12"
          isOpen={showSubscriptionModal}
          isClose={() => setShowSubscriptionModal(false)}
        >
          <EmailSubscriptionForm
            handleSubmit={handleFormSubmit}
            handleClose={() => setShowSubscriptionModal(false)}
            isFacility={true}
            isLoading={isLoadingSubscription}
            title={"Wound Analysis"}
          />
        </Modalant>
      )}
      <ExcelExport
        ref={excelExporter}
        data={[]}
        fileName={`Wound Analysis Report - ${
          woundFacility?.label ?? woundFacility?.[0]?.label ?? ""
        } ${moment(startDate).format("MM-DD-YYYY")} to ${moment(endDate).format(
          "MM-DD-YYYY"
        )}.xlsx`}
      />
    </div>
  );
};

export default WoundAnalysisReport;
